import React, { FC } from 'react';
import moment from 'moment';
import { FieldWrapper, DatePicker } from '@td-client-frontend/common';

interface JobDateRange {
  startDateRangeValue: Date;
  endDateRangeValue: Date;
  setStartDateRangeValue: (date: Date) => void;
  setEndDateRangeValue: (date: Date) => void;
  dateRangeError: boolean;
}

export const JobDateRange: FC<JobDateRange> = ({
  startDateRangeValue,
  setStartDateRangeValue,
  endDateRangeValue,
  setEndDateRangeValue,
  dateRangeError
}) => {
  const validDate = (date: any) => {
    return moment(date).isValid();
  };

  return (
    <div className="flex space-x-4 min-w-24 items-end">
      <FieldWrapper
        label="Date range"
        error={dateRangeError ? 'Date range must be less than 6 months.' : undefined}
        isError={dateRangeError}
      >
        <div className="flex flex-row space-x-4">
          <DatePicker
            name="from"
            placeholder="MM/DD/YYYY"
            onChange={(date: Date) => setStartDateRangeValue(date)}
            selected={startDateRangeValue}
            selectsStart
            closeOnScroll
            startDate={startDateRangeValue}
            endDate={endDateRangeValue}
            maxDate={endDateRangeValue}
            wrapperClasses="flex flex-col w-full"
            fieldLabelClasses="hidden"
            errorClassName={validDate(startDateRangeValue) ? 'hidden' : undefined}
            isError={!validDate(startDateRangeValue)}
            error={!validDate(startDateRangeValue) ? 'Date should be valid' : undefined}
          />
          <DatePicker
            name="to"
            placeholder="MM/DD/YYYY"
            onChange={(date: Date) => setEndDateRangeValue(date)}
            selected={endDateRangeValue}
            selectsEnd
            closeOnScroll
            startDate={startDateRangeValue}
            endDate={endDateRangeValue}
            minDate={startDateRangeValue}
            wrapperClasses="flex flex-col w-full"
            fieldLabelClasses="hidden"
            errorClassName={validDate(endDateRangeValue) ? 'hidden' : undefined}
            isError={!validDate(endDateRangeValue)}
            error={!validDate(endDateRangeValue) ? 'Date should be valid' : undefined}
          />
        </div>
      </FieldWrapper>
    </div>
  );
};
